///include /assets/js/app/p/user.js

const globalSearch = Vue.component('global-search', {
    template: "#global-search",
    props: {
        user: {
            type: User,
            required: true,
        },
    },
    data() {
        return {
            debounce: null,
            search: "",
            domains: null,
            packages: null,
            servers: null,
            navigation: null,
            stackUsers: null,
            showResults: false,
            recentlyVisited: [],
            previousFocus: null,
            recentlyVisitedFetched: null,
        }
    },
    watch: {
        search(v) {
            if (v) {
                this.ajaxDebounce(() => {
                    this.packages = null
                    this.domains = null
                    this.navigation = null
                    this.stackUsers = null
                    this.servers = null

                    const packageReq = this.buildRequest(v)
                    const domainReq = this.buildRequest(v)

                    $.ajax({
                        method: "get",
                        url: `/o/package`,
                        data: packageReq
                    }).then(r => this.packages = r)

                    $.ajax({
                        method: "get",
                        url: `/a/managed_vps`,
                    }).then(r => {
                        this.servers = r.filter(s => s.name.toLowerCase().includes(this.search.toLowerCase()) && s.productSpec.split('-')[0] == 'cloud')
                    })

                    $.ajax({
                        method: "get",
                        url: `/o/domain`,
                        data: domainReq
                    }).then(r => this.domains = r)

                    $.ajax({
                        method: "post",
                        url: `/a/navigationSearch`,
                        data: {
                            search: this.search,
                            isReseller: this.isReseller
                        }
                    }).then(r => this.navigation = r)

                    $.ajax(`/a/reseller/*/explicitStackUser`).then(r => {
                        // filter returned users based on search query
                        this.stackUsers = r.filter(s => {
                            return (s.contact?.person_name.toLowerCase().includes(this.search.toLowerCase()) || s.name.toLowerCase().includes(this.search.toLowerCase()))
                        }).slice(0, 5);
                    })
                }, 1000)
            }
        }
    },
    computed: {
        isReseller() {
            return this.user.hasReseller
        },
    },
    methods: {
        ajaxDebounce(cb, timeout) {
            clearTimeout(this.debounce)
            this.debounce = null
            this.debounce = setTimeout(() => {
                cb()
            }, timeout)
        },
        buildRequest(search) {
            const fields = ["name", "id"]

            return {
                fields: fields,
                selector: {
                    name: search ? {
                        '$regex': "^" + search.replace(
                            /.*\//,
                            ""
                        ).replace(
                            /([.?+*\(\)\[\]\{\}-])/g,
                            (s, m1) => `[${m1}]`
                        ).replace(/\\/, "\\\\"),
                    } : undefined,
                },
                sort: ["name"],
                limit: 5
            }
        },
        getRecentlyVisited() {
            if (!this.recentlyVisitedFetched) {
                this.recentlyVisitedFetched = true;
                $.ajax(`/a/recently_visited`).then(r => this.recentlyVisited = r)
            }
        }
    },
    async mounted() {
        // document.querySelectorAll(".searchbox").forEach((element) => {
        //     element.addEventListener("click", (event) => {
        //         event.stopPropagation(); // Prevent the event from bubbling up
        //         if (!this.recentlyVisitedFetched) {
        //             this.recentlyVisitedFetched = true;
        //             this.getRecentlyVisited();
        //         }
        //     });
        // });

        document.addEventListener("keyup", (event) => {
            event.preventDefault();
            if (event.keyCode == 191) {
                let activeFocus = false;
                // Check that no input or text area is focused. If it isn't then focus the global search
                $('input').each(function() {
                    if ($(this).is(':focus')) {
                        activeFocus = true
                    }

                    if (activeFocus) {
                        return false;
                    }
                });

                if (!activeFocus) {
                    $('textarea').each(function() {
                        if ($(this).is(':focus')) {
                            activeFocus = true
                        }

                        if (activeFocus) {
                            return false;
                        }
                    });
                }

                if (!activeFocus) {
                    document.getElementById("search-input").focus();
                    this.showResults = true
                }
            }
            if (event.keyCode === 27 && this.showResults === true) {
                this.showResults = false
                $('input').next().focus()
            }

        });

        addEventListener('click', (event) => {
            if (event.target.id != 'global-search-container' && event.target.id != 'search-input' && event.target.id != 'global-search-heading') {
                this.showResults = false
            }

            if (event.target.id == 'search-input') {
                this.showResults = true
            }
        });
    }
})